/* eslint-disable react-hooks/exhaustive-deps */
import { Font } from "@react-pdf/renderer";
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../../assets/fonts/rudawregular2.ttf';
import PostService from '../../../../services/postService';
import { useCompany } from '../../../../provider/companyProvider';
import { wrap } from 'comlink';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';


// ✅ Modern worker import (Webpack 5 / Vite)
const worker = new Worker(new URL('./pdfPagePostListWorker.js', import.meta.url));
const workerApi = wrap(worker);

const registerFont = () => {
  Font.register({
    family: 'Rudaw',
    fonts: [{ src: Rudaw, fontWeight: 'normal' }],
  });
};

const PdfPagePostList = ({ data }) => {
  const { i18n, t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const handlePrint = async () => {
    registerFont();
    setIsLoading(true);

    const filters = data && {
      name: data.name,
      streetId: data.streetId,
      cityId: data.cityId,
      driverId: data.driverId,
      branch: data.branch && data.branch.Id,
      pageId: data.pageId,
      postStatusId: data.postStatusId,
      type: data.type,
      isPagePaid: data.isPagePaid,
      isDriverPaid: data.isDriverPaid,
      ...data.time,
      ...data.sort,
      ids: data.ids
    };

    try {
      // Fetch data
      const response = await PostService.fetchByPage(filters);
      const responseData = response;


      const translations = {
        pageReport: t('pageReport'),
        number: t('number'),
        receiverPhoneTable: t('receiverPhoneTable'),
        amount: t('amount'),
        cityAmount: t('cityAmount'),
        netAmount: t('netAmount'),
        id: t('id'),
        time: t('time'),
        address: t('address'),
        branch: t('branch'),
        date: t('date'),
        status: t('status'),
        type: t('type'),
        totalPosts: t('totalPosts'),
        totalPostAmount: t('totalPostAmount'),
        totalTransportationAmount: t('totalTransportationAmount'),
        netPostAmount: t('netPostAmount'),
        totalItems: t('totalItems'),
        new: t('new'),
        change: t('change'),
        today: t('today'),
        week: t('week'),
        month: t('month'),
        custom: t('custom'),
        yesterday: t('yesterday'),
        daybeforeyesterday: t('daybeforeyesterday')
      };

      // Generate PDF
      const blobUrl = await workerApi.renderPDF({
        branch: data.branch,
        time: data.time,
        business,
        responseData,
        t: translations,
        language: i18n.language,
      });
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading
    ? <CircularProgress size={20} />
    : <FacebookOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />;
};

export default PdfPagePostList;